import React from 'react';
import { FieldErrorContainer, FieldErrorWrapper } from './styles';

type Props = {
  message: string;
};

const FieldError = (props: Props) => (
  <FieldErrorContainer>
    <FieldErrorWrapper>{props.message}</FieldErrorWrapper>
  </FieldErrorContainer>
);

export default FieldError;
